import React, { FunctionComponent } from 'react';
import { PersonShowModalSkillState } from './types';
import { TextBox } from '../../atoms/textBox';
import { RemainingLength } from '../../atoms/remainingLength';

type Props = {
  state: PersonShowModalSkillState;
  target: string;
  onChangeBody: (name: string, value: string) => void;
  handleClick: (skillTitle: string) => void;
  handleDelete: (skillTitle: string) => void;
  handleSend: (value: string) => void;
  handleClearSuggest: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  target,
  onChangeBody,
  handleClick,
  handleDelete,
  handleSend,
  handleClearSuggest
}) => {
  return (
    <div className="person__show__modal__inner" onClick={handleClearSuggest}>
      <p className="person__show__modal__inner--title">
        候補の中から選択するか入力して保存してください
      </p>
      <div className="person__show__modal__inner__skills">
        <TextBox
          className="person__show__modal__inner__skills--input"
          placeholder="スキル・特徴・資格を入力してください"
          onChanged={(name, value) => onChangeBody(name, value)}
          name="targetSkill"
          value={state.targetSkill}
          handleSend={() => handleSend(state.targetSkill)}
          enterKeyHint='done'
          maxLength={255}
        />
        <RemainingLength
          remaining={255 - state.targetSkill.length}
          className="person__show__modal__inner--hint"
        />
        <ul
          className={`person__show__modal__inner__skills--suggestions ${
            state.suggestSkills.length > 0 ? 'active' : ''
          }`}
        >
          {state.suggestSkills.map(skill => (
            <li key={skill.title} onClick={() => handleClick(skill.title)}>
              <p className="skill--title">{skill.title}</p>
              <p className="skill--count">{skill.count}人が登録しています</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="person__show__modal__inner__skills--box">
        <p className="semiTitle">追加したスキル・特徴・資格</p>
        {state.skills.length > 0 ? (
          <ul>
            {state.skills.map(skill => (
              <li key={skill}>
                <span>{skill}</span>
                <svg
                  onClick={() => handleDelete(skill)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z"
                    fill="#19190F"
                  />
                </svg>
              </li>
            ))}
          </ul>
        ) : (
          <p className="person__show__modal__inner__skills--empty">スキル・特徴・資格はまだ追加されていません</p>
        )}
      </div>
      <div className="person__show__modal__inner__skills--box">
        <p className="semiTitle">候補</p>
        {state.recommendSkills.length > 0 ? (
          <ul className="suggestions">
            {state.recommendSkills.map(skill => (
              <li key={skill} onClick={() => handleClick(skill)}>
                <p className="skill--title">{skill}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p className="person__show__modal__inner__skills--empty">候補はありません</p>
        )}
      </div>
    </div>
  );
};
